import React from "react";
import { Link } from 'react-router-dom';

//Drop down menu for user options
const Menu = ({
  visible,
  close,
  company,
  logout,
  color
}) => {

  return (
    <div
      className={visible ? "menu-wrapper" : "d-none"}
      onClick={() => close()}
    >
      <div className="menu-popup">
        <ul className="list-group">

          <Link className="list-group-item" to={`/${company}/account`}>
            <div className="menu-item">
              <div className="row">
                <div className="col-2">
                  <i className="fas fa-user" style={{ color: color }}
                  >
                  </i>
                </div>
                <div className="col-10">Account</div>
              </div>
            </div>
          </Link>

          <li className="list-group-item">
            <div
              className="menu-item"
              onClick={() => logout() }
            >
              <div className="row">
                <div className="col-2">
                  <i
                    className="fas fa-sign-out-alt"
                    style={{ color: color }}
                  ></i>
                </div>
                <div className="col-10">Log out</div>
              </div>
            </div>
          </li>

          <li className="list-group-item">
            <div className="menu-item"
                  onClick={() => close()}  
            >
              <div className="row">
                <div className="col-2">
                  <i className="fas fa-times" style={{ color: color }}></i>
                </div>
                <div className="col-10">Close</div>
              </div>
            </div>
          </li>

        </ul>
      </div>
    </div>
  );
  
}

export default Menu;
